import { InjectionToken } from '@angular/core';

/**
 * Contract every app must satisfy so shared API-client code can attach an
 * `Authorization` header without depending on a concrete `AuthService`.
 *
 *  - On web, the `AuthService` already in `apps/web` implements this.
 *  - On mobile, the Stage-18 token-bag service will implement this against
 *    secure native storage.
 */
export interface AuthHeaderProvider {
  /**
   * Returns the active bearer token for the current session, or `null` if
   * the user is unauthenticated. Implementations MUST NOT throw.
   */
  getToken(): string | null;
}

/**
 * DI token consumed by shared API services. Each app supplies its own
 * `AuthHeaderProvider` implementation at bootstrap.
 */
export const AUTH_HEADER_PROVIDER = new InjectionToken<AuthHeaderProvider>(
  'vevents.api.authHeaderProvider'
);
